var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"facet-route-info-item"}},[_c('div',{staticClass:"facet-route-info-container"},[_c('div',{staticClass:"facet-route-info-panel"},[_c('journey-list-panel',{attrs:{"userClassList":_vm.userClassList,"activeFacets":_vm.activeFacets,"userId":_vm.userId}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }